module.exports = __webpack_public_path__ + "static/media/old reitway-global-property-i.12efe3e5.csv";